import {CHAT} from "../../actions/chat/chatActionTypes";

const INITIAL_STATE = {
    chatId: "",
    typeChat: "default",
    chatMessagesSend: [],
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case CHAT.SET_CHAT_ID:
            return {...state, chatId: action.payload};
            case CHAT.SET_TYPE_CHAT:
            return {...state, typeChat: action.payload};
            case CHAT.SET_ADD_MESSAGES_SENT_ARR:
            return {...state, chatMessagesSend: [...state.chatMessagesSend, action.payload]};
            case CHAT.CLEAR_SENT_ARR:
            return {...state, chatMessagesSend: []};
            case CHAT.REMOVE_FIRST_MATCHING_MESSAGE:
            const indexToRemove = state.chatMessagesSend.findIndex(msg => msg === action.payload);
            if (indexToRemove === -1) return state;

            return {
                ...state,
                chatMessagesSend: [
                    ...state.chatMessagesSend.slice(0, indexToRemove),
                    ...state.chatMessagesSend.slice(indexToRemove + 1),
                ],
            };

        default:
            return state;
    }
}
